module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading pa-0"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.requests.get.loading,
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 0;
        _vm.get()
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mr-3",
    attrs: {
      "vertical": ""
    }
  }), _vm._v("\n    " + _vm._s(_vm.value.first_name) + " " + _vm._s(_vm.value.last_name) + " "), _c('v-chip', {
    staticClass: "ml-2",
    attrs: {
      "outline": "",
      "small": "",
      "label": ""
    }
  }, [_vm._v(_vm._s(_vm.value.id))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "text": "",
      "disabled": _vm.window === 0
    },
    on: {
      "click": function($event) {
        _vm.window = 0
      }
    }
  }, [_vm._v("Programs")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "outlined": "",
      "color": "primary",
      "disabled": _vm.window === 1
    },
    on: {
      "click": function($event) {
        _vm.window = 1
      }
    }
  }, [_vm._v("Assign a new program")]), _vm._v(" "), (_vm.physitrackClientId && _vm.clientLink) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "text": "",
      "flat": "",
      "href": _vm.clientLink,
      "target": "_blank",
      "color": "primary"
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": "",
      "md4": ""
    }
  }, [_c('v-list', {
    attrs: {
      "dense": "",
      "one-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "subheading"
  }, [_vm._v("Programs")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "outline": "",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 1
      }
    }
  }, [_vm._v("New"), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [(_vm.hasActivePrograms) ? _c('program-list', {
    attrs: {
      "programs": _vm.currentlyActivePrograms,
      "title": "Active program"
    },
    on: {
      "selected": _vm.setActiveProgram
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasActivePrograms && !_vm.requests.get.loading) ? _c('v-alert', {
    attrs: {
      "outline": "",
      "value": true,
      "type": "info"
    }
  }, [_vm._v("\n                No currently active program\n                "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 1
      }
    }
  }, [_vm._v("Assign a program")])], 1) : _vm._e(), _vm._v(" "), (_vm.previousPrograms && _vm.previousPrograms.length > 0) ? _c('program-list', {
    attrs: {
      "programs": _vm.previousPrograms,
      "title": "Previous"
    },
    on: {
      "selected": _vm.setActiveProgram
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm7": "",
      "md8": ""
    }
  }, [(_vm.selectedProgram && _vm.selectedProgram.id) ? _c('program', {
    attrs: {
      "dateOfBirth": _vm.yearOfBirth,
      "physitrack-client-id": _vm.physitrackClientId
    },
    model: {
      value: (_vm.selectedProgram),
      callback: function($$v) {
        _vm.selectedProgram = $$v
      },
      expression: "selectedProgram"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [(_vm.physitrackClientId && _vm.relationshipId) ? _c('assign-program', {
    attrs: {
      "physitrack-client-id": _vm.physitrackClientId,
      "relationship-id": _vm.relationshipId,
      "has-active-program": _vm.hasActivePrograms,
      "touch": _vm.assignTouch
    },
    on: {
      "assigned": _vm.programAssigned,
      "close": function($event) {
        _vm.window = 0
      }
    },
    model: {
      value: (_vm.physitrackClient),
      callback: function($$v) {
        _vm.physitrackClient = $$v
      },
      expression: "physitrackClient"
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15cd8a04","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/Physitrack/Programs.vue
// module id = 1336
// module chunks = 9